
import { defineComponent } from "vue";
import PostTile from "./PostTile.vue";

export default defineComponent({
  components: { PostTile },
  props: { posts: { type: Array, default: () => [] } },
});
